<template>
  <div class="meeting_room_reservation">
    <!-- title -->
    <div class="title">
      我的订单
      <span class="small">预订记录</span>
    </div>
    <!-- content -->
    <div class="content">
      <!-- 表单查询等相关操作 -->
      <el-form :model="form" :inline="true">
        <el-form-item label="活动名称">
          <el-input class="input-width" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: ""
      }
    };
  },
  methods:{
      onSubmit(){
          console.log('搜索');
      }
  }
};
</script>

<style lang="scss" scoped>
@import "../../index.scss";
</style>